import React from 'react';

import Heading from '@atlaskit/heading';

export const MainContentHeaders = ({ children }: { children: React.ReactNode }) => (
	<Heading as="h5" size="small">
		{children}
	</Heading>
);
